export default __webpack_public_path__ + "static/media/asset-3.ee3c58d8.svg";